import React from "react";

import { LuCheck } from "react-icons/lu";

import { ReactComponent as TribeLogo } from "../../../assets/TribeLogo.svg";



// The player supplies real questions, saved answers, and quiz actions.

// Without questions this remains lesson 14's brief introduction.

export default function FinalQuiz({

  questions = [], index = 0, answers = {}, loading = false, review = false,

  error = "", headingRef, onSelect, onMove, onReview, onSubmit,

  onBackToQuestions,

} = {}) {

  if (!questions.length) return <div className="host-final-quiz-intro">

    <style>{STYLES}</style>

    <section aria-label="Start the final quiz">

      <h1>Start quiz</h1>

      <p className="quiz-intro-detail">You’ll answer <strong>18 multiple-choice questions</strong> covering what you’ve learned.<br />You need <strong>85% to pass</strong> and have <strong>up to four attempts</strong>.</p>

    </section>

  </div>;



  const question = questions[index];

  const selected = answers[question.questionId];

  const visible = Math.min(8, questions.length);

  const windowStart = Math.max(0, Math.min(questions.length - visible, index - (visible - 1)));

  const shift = windowStart * 100 / questions.length;

  const edge = 50 / questions.length;



  return <div className="host-final-quiz-page"><style>{STYLES}</style>

    <main className="final-quiz">

      <header className="training-header">

        <TribeLogo className="training-logo" role="img" aria-label="Tribe" />

        <div className="training-header-progress final-quiz-header-progress" aria-label={`Question ${index + 1} of ${questions.length}`}>

          <div className={`quiz-step-viewport ${windowStart > 0 ? "has-hidden-before" : ""} ${windowStart + visible < questions.length ? "has-hidden-after" : ""}`}>

            <div className="training-step-progress quiz-step-progress" style={{"--quiz-count":questions.length,"--quiz-visible":visible,transform:`translateX(-${shift}%)`}}>

              <div className="training-step-line" style={{left:`${edge}%`,right:`${edge}%`}} />

              <div className="training-step-active-line" style={{left:`${edge}%`,width:`${index / questions.length * 100}%`}} />

              {questions.map((_, step) => <span key={step} className={`training-step-node ${step < index ? "is-complete" : ""} ${step === index ? "is-current" : ""}`} aria-current={step === index ? "step" : undefined}>{step < index ? <LuCheck size={8} /> : null}</span>)}

            </div>

          </div>

          <div className="training-progress-context"><strong>Final Quiz</strong></div>

        </div>

        <div className="training-header-title">HOST TRAINING MODULE</div>

      </header>

      <section>

        {review ? <>

          <h1 ref={headingRef} tabIndex={-1}>Ready to submit?</h1>

          <p className="quiz-review-note">Review your answers before submitting your attempt.</p>

          <div className="quiz-review-grid">{questions.map((item, i) => <button type="button" key={item.questionId} onClick={() => onMove(i)} aria-label={`Review question ${i + 1}`} disabled={loading}><span>{i + 1}</span><strong>{answers[item.questionId] || "—"}</strong></button>)}</div>

          <nav><button type="button" className="training-button is-secondary" onClick={onBackToQuestions} disabled={loading}>Back to questions</button><button type="button" className="training-button" onClick={onSubmit} disabled={loading || !questions.every(item => answers[item.questionId])}>{loading ? "Submitting…" : "Submit quiz"}</button></nav>

        </> : <>

          <div className="eyebrow">QUESTION {index + 1}/{questions.length}</div>

          <h1 ref={headingRef} tabIndex={-1} className={question.prompt.length > 260 ? "is-very-long" : question.prompt.length > 160 ? "is-long" : ""}>{question.prompt}</h1>

          <div className="final-options" role="group" aria-label="Choose one answer">

            {question.choices.map(choice => <button type="button" key={choice.value} className={selected === choice.value ? "is-selected" : ""} aria-pressed={selected === choice.value} onClick={() => onSelect(choice.value)} disabled={loading}><span>{choice.value}</span><strong>{choice.label}</strong></button>)}

          </div>

          <nav><button type="button" className="training-button is-secondary" onClick={() => onMove(index - 1)} disabled={index === 0 || loading}>Back</button><div className="training-next-group"><button type="button" className="training-button" onClick={() => index === questions.length - 1 ? onReview() : onMove(index + 1)} disabled={!selected || loading}>{index === questions.length - 1 ? "Review answers" : "Continue"}</button></div></nav>

        </>}

        {error && <div className="training-error" role="alert">{error}</div>}

      </section>

      <div className="training-document-footer" aria-hidden="true">© 2026 Tribe, Inc. All rights reserved.</div>

    </main>

  </div>;

}



const STYLES = `

 .host-final-quiz-page {--training-ink:#111111;--training-muted:#707070;--training-line:#dddddd;--training-soft:#f5f5f5;--training-white:#fff;--training-canvas:#f6f6f4;--training-paper-edge:#e2e2de;min-height:100vh;background:var(--training-canvas);color:var(--training-ink);font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}

 .host-final-quiz-page * {box-sizing:border-box;}

 .host-final-quiz-page button {font:inherit;}

 .host-final-quiz-page button:disabled {opacity:.4;cursor:not-allowed;}

 .host-final-quiz-page button:focus-visible {outline:2px solid #111;outline-offset:4px;}

 .host-final-quiz-page .training-logo {height:auto;display:block;}

 .host-final-quiz-page .eyebrow {font-size:10px;font-weight:750;letter-spacing:.09em;color:#797975;}

  .host-final-quiz-page .training-player, .host-final-quiz-page .final-quiz, .host-final-quiz-page .result-page {

    width: calc(100% - 56px);

    max-width: 1180px;

    min-height: 100vh;

    margin: 0 auto;

    padding: 14px 42px 16px;

    background: var(--training-white);

    border-inline: 0px solid var(--training-paper-edge);

  }





  .host-final-quiz-page .training-header {

    height: 72px;

    display: grid;

    grid-template-columns: 1fr minmax(280px, 430px) 1fr;

    align-items: center;

    gap: 24px;

  }



  .host-final-quiz-page .training-header .training-logo {

    width: 92px;

    justify-self: start;

  }



  .host-final-quiz-page .training-header-title {

    justify-self: end;

    color: #111111;

    font-size: 12px;

    font-weight: 700;

    letter-spacing: .055em;

    white-space: nowrap;

  }



  .host-final-quiz-page .training-header-progress {

    width: 100%;

    max-width: 430px;

    justify-self: center;

    overflow: visible;

  }





  .host-final-quiz-page .final-quiz-header-progress {

    position: relative;

    height: 72px;

    align-self: stretch;

    overflow: visible;

  }



  /*

   * This viewport sits on the exact vertical midpoint of the

   * 72px header, matching the Tribe logo and module title.

   */

  .host-final-quiz-page .quiz-step-viewport {

    position: absolute;

    left: 50%;

    top: 50%;

    width: 100%;

    height: 22px;

    overflow: hidden;

    transform: translate(-50%, -50%);

  }



  /*

   * Full 12-step rail is 150% of the viewport width.

   * 12 / 1.5 = 8 visible step positions.

   */

  .host-final-quiz-page .quiz-step-progress {

    width: calc(100% * var(--quiz-count) / var(--quiz-visible));

    grid-template-columns: repeat(var(--quiz-count), 1fr);

    padding-inline: 0;

    -webkit-mask-image: none;

    mask-image: none;

    transition: transform .32s ease;

    will-change: transform;

  }



  /*

   * Beginning: no left fade because nothing is hidden there.

   * Fade the right edge where step 8 exits the viewport.

   */

  .host-final-quiz-page .quiz-step-viewport.has-hidden-after:not(.has-hidden-before) {

    -webkit-mask-image: linear-gradient(

      to right,

      #000 0%,

      #000 78%,

      rgba(0,0,0,.9) 84%,

      rgba(0,0,0,.55) 91%,

      rgba(0,0,0,.18) 97%,

      transparent 100%

    );

    mask-image: linear-gradient(

      to right,

      #000 0%,

      #000 78%,

      rgba(0,0,0,.9) 84%,

      rgba(0,0,0,.55) 91%,

      rgba(0,0,0,.18) 97%,

      transparent 100%

    );

  }



  /*

   * Middle: there are hidden questions on both sides.

   */

  .host-final-quiz-page .quiz-step-viewport.has-hidden-before.has-hidden-after {

    -webkit-mask-image: linear-gradient(

      to right,

      transparent 0%,

      rgba(0,0,0,.18) 3%,

      rgba(0,0,0,.55) 9%,

      rgba(0,0,0,.9) 16%,

      #000 22%,

      #000 78%,

      rgba(0,0,0,.9) 84%,

      rgba(0,0,0,.55) 91%,

      rgba(0,0,0,.18) 97%,

      transparent 100%

    );

    mask-image: linear-gradient(

      to right,

      transparent 0%,

      rgba(0,0,0,.18) 3%,

      rgba(0,0,0,.55) 9%,

      rgba(0,0,0,.9) 16%,

      #000 22%,

      #000 78%,

      rgba(0,0,0,.9) 84%,

      rgba(0,0,0,.55) 91%,

      rgba(0,0,0,.18) 97%,

      transparent 100%

    );

  }



  /*

   * End: no right fade because question 12 is the end.

   */

  .host-final-quiz-page .quiz-step-viewport.has-hidden-before:not(.has-hidden-after) {

    -webkit-mask-image: linear-gradient(

      to right,

      transparent 0%,

      rgba(0,0,0,.18) 3%,

      rgba(0,0,0,.55) 9%,

      rgba(0,0,0,.9) 16%,

      #000 22%,

      #000 100%

    );

    mask-image: linear-gradient(

      to right,

      transparent 0%,

      rgba(0,0,0,.18) 3%,

      rgba(0,0,0,.55) 9%,

      rgba(0,0,0,.9) 16%,

      #000 22%,

      #000 100%

    );

  }



  /*

   * Final Quiz is visually below the bar but absolutely

   * positioned so it does not pull the bar above center.

   */

  .host-final-quiz-page .final-quiz-header-progress .training-progress-context {

    position: absolute;

    left: 50%;

    top: calc(50% + 22px);

    width: max-content;

    margin-top: 0;

    transform: translateX(-50%);

  }





  .host-final-quiz-page .training-progress-context {

    display: flex;

    align-items: baseline;

    justify-content: center;

    gap: 6px;

    margin-top: 5px;

    text-align: center;

    white-space: nowrap;

  }



  .host-final-quiz-page .training-progress-context strong {

    color: #333330;

    font-size: 12px;

    font-weight: 650;

    line-height: 1;

    letter-spacing: -.015em;

  }



  .host-final-quiz-page .training-progress-context span {

    color: #333330;

    font-size: 9px;

    font-weight: 550;

    line-height: 1;

  }



  .host-final-quiz-page .training-progress-context i {

    color: #c2c2bd;

    font-size: 9px;

    font-style: normal;

  }



  .host-final-quiz-page .training-step-line, .host-final-quiz-page .training-step-active-line {

    position: absolute;

    z-index: 0;

    left: 5%;

    top: 50%;

    height: 3px;

    border-radius: 999px;

    transform: translateY(-50%);

  }



  .host-final-quiz-page .training-step-line {

    right: 5%;

    background: #d7d7d3;

  }



  .host-final-quiz-page .training-step-active-line {

    overflow: hidden;

    max-width: 90%;

    background: #111111;

    transition: width .28s ease;

  }



  .host-final-quiz-page .training-step-active-line::after {

    content: "";

    position: absolute;

    inset: 0;

    width: 30%;

    background: linear-gradient(

      90deg,

      transparent 0%,

      rgba(255,255,255,.06) 30%,

      rgba(255,255,255,.34) 50%,

      rgba(255,255,255,.06) 70%,

      transparent 100%

    );

    transform: translateX(-150%);

    animation: training-progress-shimmer 1.9s ease-in-out infinite;

  }



  .host-final-quiz-page .training-step-node {

    position: relative;

    z-index: 1;

    width: 14px;

    height: 14px;

    display: grid;

    place-items: center;

    justify-self: center;

    border: 1.5px solid #bdbdb8;

    border-radius: 50%;

    background: #ffffff;

    color: #ffffff;

    font-size: 7px;

    font-weight: 700;

  }



  .host-final-quiz-page .training-step-node.is-complete {

    border-color: #111111;

    background: #111111;

    color: #ffffff;

  }



  .host-final-quiz-page .training-step-node.is-complete svg {

    display: block;

    stroke: currentColor;

  }



  .host-final-quiz-page .training-step-node.is-current {

    border: 2.5px solid #111111;

    background: #ffffff;

    box-shadow: 0 0 0 4px rgba(17,17,17,.055);

  }







  .host-final-quiz-page .training-document-footer {

    margin-top: auto;

    min-height: 28px;

    padding-top: 9px;

    color: #a0a09b;

    font-size: 9px;

    font-weight: 500;

    letter-spacing: 0;

    text-align: left;

  }



  .host-final-quiz-page .final-quiz {

    max-width: 980px;

    display: flex;

    flex-direction: column;

  }

  .host-final-quiz-page .final-quiz > section {

    flex: 1 1 auto;

    width: min(100%, 760px);

    margin: 0 auto;

    padding: 60px 0;

  }

  .host-final-quiz-page .final-quiz h1 {

    margin: 14px 0 30px;

    color: var(--training-ink);

    font-size: clamp(40px, 5vw, 58px);

    font-weight: 850;

    line-height: 1.02;

    letter-spacing: -.055em;

  }

    .host-final-quiz-page .final-quiz h1.is-long {

  font-size: clamp(30px, 3vw, 40px);

  line-height: 1.08;

  letter-spacing: -.04em;

}



.host-final-quiz-page .final-quiz h1.is-very-long {

  font-size: clamp(24px, 2.3vw, 28px);

  line-height: 1.15;

  letter-spacing: -.025em;

  margin-bottom: 24px;

}



  .host-final-quiz-page .final-options { display: grid; gap: 10px; }

  .host-final-quiz-page .final-options > button {

    display: grid;

    grid-template-columns: 42px 1fr;

    align-items: center;

    gap: 12px;

    padding: 13px;

    border: 2px solid var(--training-line);

    border-radius: 13px;

    background: white;

    text-align: left;

    cursor: pointer;

  }

  .host-final-quiz-page .final-options > button > span { width: 34px; height: 34px; display: grid; place-items: center; border-radius: 9px; background: var(--training-soft); font-weight: 900; }

  .host-final-quiz-page .final-options > button.is-selected { border-color: var(--training-ink); background: var(--training-soft); }

  .host-final-quiz-page .final-options > button.is-selected > span { background: var(--training-ink); color: white; }

  .host-final-quiz-page .final-quiz nav {

    display: flex;

    justify-content: space-between;

    gap: 10px;

    margin-top: 28px;

  }





  .host-final-quiz-page .training-button {

    min-height: 44px;

    padding: 0 20px;

    border: 1px solid var(--training-ink);

    border-radius: 8px;

    background: var(--training-ink);

    color: white;

    font-size: 13px;

    font-weight: 760;

    cursor: pointer;

  }



  .host-final-quiz-page .training-button.is-secondary {

    border-color: var(--training-line);

    background: white;

    color: var(--training-ink);

  }



  .host-final-quiz-page .training-button.is-wide { width: 100%; margin-top: 18px; }

  .host-final-quiz-page .training-button:disabled, .host-final-quiz-page .audio-button:disabled { opacity: .4; cursor: not-allowed; }





.host-final-quiz-page .quiz-step-progress {position:relative;display:grid;align-items:center;height:22px;padding:0;}

.host-final-quiz-page .training-next-group {display:flex;align-items:center;justify-content:flex-end;gap:12px;min-width:0;}

@keyframes training-progress-shimmer {

  0% {transform:translateX(-150%);opacity:0;}

  18%,72% {opacity:1;}

  100% {transform:translateX(360%);opacity:0;}

}

.host-final-quiz-page .final-options>button>strong {font-size:14px;line-height:1.5;}

.host-final-quiz-page .training-error {margin:18px 0;padding:13px 16px;border:1px solid #e7c3c0;border-radius:12px;color:#9a302b;background:#fff6f5;font-size:13px;line-height:1.5;}

.host-final-quiz-page .quiz-review-grid {display:grid;grid-template-columns:repeat(6,1fr);gap:10px;margin:24px 0;}

.host-final-quiz-page .quiz-review-grid button {display:flex;justify-content:space-between;align-items:center;padding:13px;border:2px solid #ddd;border-radius:13px;background:#fff;cursor:pointer;}

.host-final-quiz-page .quiz-review-note {color:#74746f;font-size:14px;line-height:1.6;}

.host-final-quiz-page h1:focus {outline:none;}

@media(max-width:800px){

 .host-final-quiz-page .final-quiz {width:100%;padding:14px 17px 18px;}

 .host-final-quiz-page .training-header {grid-template-columns:auto minmax(120px,1fr) auto;gap:10px;}

 .host-final-quiz-page .training-header-title {font-size:9px;letter-spacing:.035em;white-space:normal;text-align:right;}

}

@media(max-width:520px){

 .host-final-quiz-page .training-header .training-logo {width:84px;}

 .host-final-quiz-page .training-header-progress {max-width:230px;}

 .host-final-quiz-page .training-step-node {width:12px;height:12px;font-size:6px;}

 .host-final-quiz-page .final-quiz>section {padding:45px 0;}

 .host-final-quiz-page .final-quiz h1 {font-size:clamp(36px,9vw,48px);}

 .host-final-quiz-page .final-quiz h1.is-long {font-size:30px;}

 .host-final-quiz-page .final-quiz h1.is-very-long {font-size:24px;}

 .host-final-quiz-page .quiz-review-grid {grid-template-columns:repeat(3,1fr);}

}

@media(prefers-reduced-motion:reduce){

 .host-final-quiz-page .quiz-step-progress,.host-final-quiz-page .training-step-active-line {transition:none;}

 .host-final-quiz-page .training-step-active-line::after {animation:none;}

}

.host-final-quiz-intro {width:100%;min-height:clamp(320px,50vh,480px);padding:40px 24px;display:flex;align-items:center;justify-content:center;background:#fff;color:#111;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;text-align:center;}

.host-final-quiz-intro section {width:100%;max-width:680px;margin:0 auto;}

.host-final-quiz-intro h1 {margin:0 0 18px;font-size:clamp(32px,4vw,48px);font-weight:850;line-height:1.08;letter-spacing:-.05em;}

.host-final-quiz-intro .quiz-intro-detail {max-width:620px;margin:0 auto;font-size:14px;font-weight:400;line-height:1.65;color:#808080;}

.host-final-quiz-intro .quiz-intro-detail strong {font-weight:750;color:#333;}

.host-training .ht-lesson-layout:has(.host-final-quiz-intro) {display:block;padding:0;}

.host-training .ht-lesson-layout:has(.host-final-quiz-intro)>.ht-lesson-copy {display:none;}

.host-training .ht-lesson-visual:has(.host-final-quiz-intro) {display:block;padding:0;background:#fff;border:0;border-radius:0;}

@media(max-width:600px){.host-final-quiz-intro {min-height:300px;padding:32px 18px;}.host-final-quiz-intro .quiz-intro-detail {font-size:13px;}}

`;



Object.assign(FinalQuiz, {

  "slide": 14,

  "id": "next-steps",

  "title": "The Final Quiz",

  "section": "Operations",

  "parts": [

    {

      "part": 0,

      "narration": "You’ve reached the end of the lessons. The final step is a multiple-choice quiz covering what you’ve learned. You need at least eighty-five percent to pass, and you have up to four attempts. Once an attempt starts, training review is locked until you submit it. If you do not pass, you can review the lessons and try again while you have attempts remaining. After four unsuccessful attempts, we won’t be able to move forward with your application. If you pass, the Tribe team will review your quiz results along with your interview and follow up with a decision. Passing the quiz does not automatically make you an approved host."

    }

  ],

  "summary": [

    "19 questions. 85% to pass.",

    "Up to four attempts."

  ]

});
